import { useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router';
import type { UploadedFiles } from '../../../../../../../types/Shared';
import type { KeyPrincipalInterface } from '../../../../../../Applications/CCLFForm/type';
import { ApplicationAttachments } from '../../../../ApplicationAttachments';

interface PrincipalResumeProps {
  principal: KeyPrincipalInterface;
  files: UploadedFiles[];
  index: number;
}
export const PrincipalResume = ({ principal, files: principalFiles, index }: PrincipalResumeProps) => {
  const { id = 0 } = useParams();
  const queryClient = useQueryClient();

  return (
    <div className='border rounded-md px-4 py-2'>
      <dt className='text-sm font-medium text-gray-500 capitalize'>
        {principal.name} ({principal.ownershipPercent}%)
      </dt>
      <dd>{principal.address}</dd>
      <dd>{principal.city}</dd>
      <dd>
        {principal.state},{principal.zipCode}
      </dd>
      <dd>{principal.yearsExperience} years of Experience</dd>
      <dd className='mt-4'>
        <ApplicationAttachments
          title='Principal Resumes'
          files={principalFiles}
          applicationId={id as number}
          onUploadOrDeleteActionSuccess={() => {
            queryClient.invalidateQueries(['get-client-application']);
          }}
          field={`orgExperience.keyPrincipals.${index}.principalResumes:${principal.arrayId}`}
        />
      </dd>
    </div>
  );
};
